/**
 * Feature Flags Configuration
 * Enable/disable modules per client deployment.
 *
 * For Dr. Wilburg's Medical Services - DWMS EMR.
 */

const features = {
  client: {
    name: "Dr. Wilburg's Medical Services",
    shortName: "DWMS",
    logo: "/dwms-logo.jpg",
    primaryColor: "#052F5D",
    accentColor: "#1976d2",
  },

  core: {
    patientManagement: true,
    userManagement: true,
    authentication: true,
    profile: true,
  },

  branches: {
    enabled: false,
    branchSwitching: false,
  },

  advanced: {
    auditLog: true,
  },
};

export default features;

export const isFeatureEnabled = (path) => {
  const keys = path.split(".");
  let value = features;
  for (const key of keys) {
    if (value[key] === undefined) return false;
    value = value[key];
  }
  return value === true;
};

export const getFeatureConfig = (path) => {
  const keys = path.split(".");
  let value = features;
  for (const key of keys) {
    if (value[key] === undefined) return null;
    value = value[key];
  }
  return value;
};
